<zimmerer-route-ion-wrapper class="ion-page">
  <div *ngIf="user" class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div
      class="main-col withBottomPadding"
      [class.withTopPadding]="MobileService.isMobile"
      [class.noSlider]="!hasSliderImages"
      fxLayout="column"
      fxLayoutGap="20px"
    >
      <image-slider [fxHide]="!hasSliderImages" [page]="'profile'" fxHide.lt-lg></image-slider>

      <div fxLayout="row" fxLayout.lt-lg="column">
        <!-- nav menu -->
        <div fxHide.lt-lg class="min-menu-wrapper" fxFlex="15">
          <app-profile-nav></app-profile-nav>
        </div>

        <div id="profileComponentContent" fxFlex="85" fxFlex.xs="100">
          <h2 fxHide.gt-md class="headline">Einstellungen</h2>

          <div fxLayout="column" fxLayoutGap="20px">
            <!-- notification settings -->
            <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
              <app-about-block-header [title]="'Benachrichtigungen'" [editdisabled]="true"> </app-about-block-header>

              <!-- <div fxLayout="row">
            <div fxFlex="grow">
              Allgemein
              <span>
                <i class="fas fa-info-circle infobutton" [matTooltip]="'lorem ipsum'"></i>
              </span>
            </div>
            <div fxLayout="row" fxLayoutGap="10px">
              <div>{{user.notification_deactivated_general ? 'Aus' : 'Ein'}}</div>
              <div>
                <mat-slide-toggle [checked]="!user.notification_deactivated_general"
                (change)="matToggle('notification_deactivated_general')"></mat-slide-toggle>
              </div>
            </div>
          </div> -->

              <div fxLayout="row">
                <div fxFlex="grow" fxLayout="row" fxLayoutGap="5px">
                  <div>Kommentar</div>
                  <div>
                    <app-info-button [tooltip]="messages.texts.profile.settings.infotexts.comment"></app-info-button>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutGap="10px">
                  <div>{{ user.notification_deactivated_comment ? 'Aus' : 'Ein' }}</div>
                  <div>
                    <mat-slide-toggle
                      [checked]="!user.notification_deactivated_comment"
                      (change)="matToggle('notification_deactivated_comment')"
                    ></mat-slide-toggle>
                  </div>
                </div>
              </div>

              <div fxLayout="row">
                <div fxFlex="grow" fxLayout="row" fxLayoutGap="5px">
                  <div>Bonus</div>
                  <div>
                    <app-info-button [tooltip]="messages.texts.profile.settings.infotexts.bonus"></app-info-button>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutGap="10px">
                  <div>{{ user.notification_deactivated_bonus ? 'Aus' : 'Ein' }}</div>
                  <div>
                    <mat-slide-toggle
                      [checked]="!user.notification_deactivated_bonus"
                      (change)="matToggle('notification_deactivated_bonus')"
                    ></mat-slide-toggle>
                  </div>
                </div>
              </div>

              <div fxLayout="row">
                <div fxFlex="grow" fxLayout="row" fxLayoutGap="5px">
                  <div>E-Mail</div>
                  <div>
                    <app-info-button [tooltip]="messages.texts.profile.settings.infotexts.email"></app-info-button>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutGap="10px">
                  <div>{{ user.notification_deactivated_email ? 'Aus' : 'Ein' }}</div>
                  <div>
                    <mat-slide-toggle
                      [checked]="!user.notification_deactivated_email"
                      (change)="matToggle('notification_deactivated_email')"
                    ></mat-slide-toggle>
                  </div>
                </div>
              </div>
            </div>

            <!-- change password -->
            <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
              <app-about-block-header [title]="'Passwort ändern'" [editdisabled]="true"> </app-about-block-header>

              <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutAlign="start center" fxLayoutGap="15px">
                <div fxLayout="row" fxLayoutAlign="center center">
                  <button (click)="changePassword()">Passwort ändern</button>
                </div>
              </div>
            </div>

            <!-- delete company profile -->
            <div class="infoblock" fxLayout="column" fxLayoutGap="10px" *ngIf="user && user.company_profile">
              <app-about-block-header [title]="'Unternehmensprofil löschen'" [editdisabled]="true">
              </app-about-block-header>

              <div
                fxLayout="column"
                fxLayout.gt-sm="row"
                fxLayoutAlign="start center"
                fxLayoutAlign.gt-sm="start stretch"
                fxLayoutGap="15px"
              >
                <div fxFlex="80">
                  Hier kannst du dein Unternehmensprofil löschen. Alle Marktplatzanzeigen und Jobinserate werden
                  gelöscht. Blog Beiträge und Wiki Artikel werden einem anonymen Profil zugeordnet.
                </div>

                <div fxLayout="row" fxLayoutAlign="center center">
                  <button class="red-button mobileGrowBtn" (click)="deleteCompanyProfile()">
                    Unternehmensprofil löschen
                  </button>
                </div>
              </div>
            </div>

            <!-- delete profile -->
            <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
              <app-about-block-header [title]="'Profil löschen'" [editdisabled]="true"> </app-about-block-header>

              <div
                fxLayout="column"
                fxLayout.gt-sm="row"
                fxLayoutAlign="start center"
                fxLayoutAlign.gt-sm="start stretch"
                fxLayoutGap="15px"
              >
                <div fxFlex="80">
                  Hier kannst du dein Profil löschen. Alle Marktplatzanzeigen und Jobinserate werden gelöscht. Blog
                  Beiträge und Wiki Artikel werden einem anonymen Profil zugeordnet. Solltest du deine Blog oder
                  Wikibeiträge löschen wollen, kannst du Sie in deinem Profil unter "Deine Beiträge" löschen.
                </div>

                <div fxLayout="row" fxLayoutAlign="center center">
                  <button class="red-button mobileGrowBtn" (click)="deleteProfile()">Profil löschen</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</zimmerer-route-ion-wrapper>
